import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { EventDot } from "@/javascript/presentation/components"

type Props = {
  children?: React.ReactNode;
  color?: React.CSSProperties['color']
  text?: string
}

const MapSubtitleItem: React.FC<Props> = ({ children, color, text }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
      <Box sx={{ color: color }}>{children}</Box>
      <EventDot color={color} />
      <Typography variant='body1'>{text}</Typography>
    </Box>
  );
}

export default MapSubtitleItem
